import { ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { EMPTY, concat, from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { FormValidationResult } from '@appTypes/formType';
import { Actions, actions } from '@redux/modules/user';
import { TypedEpic } from './types';

const validateFormEpic: TypedEpic = (action$) =>
  action$.pipe(
    ofType(Actions.VALIDATE_FORM),
    mergeMap((action: ActionType<typeof actions.validateForm.request>) =>
      from(
        apiClient.post<FormValidationResult>(ApiType.apimFormApi, {
          url: ApiPaths[ApiType.apimFormApi].forms.validate,
          data: action.payload,
        }),
      ).pipe(
        mergeMap(({ data }) =>
          concat(
            of(actions.validateForm.success(data)),
            data?.result?.isValid ? of(actions.postForm.request(action.payload)) : EMPTY,
          ),
        ),
        catchError((err) => of(actions.validateForm.failure(err))),
      ),
    ),
  );

const postFormEpic: TypedEpic = (action$) =>
  action$.pipe(
    ofType(Actions.POST_FORM),
    mergeMap((action: ActionType<typeof actions.postForm.request>) =>
      from(
        apiClient.post(ApiType.apimFormApi, {
          url: ApiPaths[ApiType.apimFormApi].forms.submit,
          data: action.payload,
        }),
      ).pipe(
        map(() => actions.postForm.success()),
        catchError((err) => of(actions.postForm.failure(err))),
      ),
    ),
  );

export const epics: TypedEpic[] = [validateFormEpic, postFormEpic];
